module.exports = __webpack_public_path__ + "img/imagecolor.6be73779.svg";